import { MARKED_OPTIONS, MarkedRenderer } from 'ngx-markdown';
import { Tokens } from 'marked';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function provideMarkdownAnchorOptions() {
  return {
    provide: MARKED_OPTIONS,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    useFactory: () => ({
      renderer: openAnchorBlankFactory()
    })
  };
}

function openAnchorBlankFactory(): MarkedRenderer {
  const renderer = new MarkedRenderer();

  renderer.link = ({ text, title, href }: Tokens.Link): string => {
    const hrefValue = href || '';
    const titleAttr = title ? ` title="${title}"` : '';

    return `<a href="${hrefValue}" target="_blank" rel="noopener noreferrer"${titleAttr}>${text}</a>`;
  };
  return renderer;
}
